import {
  ScriptStepPermissionConfigOptionDef,
  ScriptStepPermissionDef,
} from 'xm-constants/scriptStepPermissionDef';

export const GET_LIBRARIES = 'GET_LIBRARIES';
export const GET_LIBRARIES_START = `${GET_LIBRARIES}_START`;
export const GET_LIBRARIES_SUCCESS = `${GET_LIBRARIES}_SUCCESS`;
export const GET_LIBRARIES_FAIL = `${GET_LIBRARIES}_FAIL`;

export const CREATE_LIBRARY = 'CREATE_LIBRARY';
export const CREATE_LIBRARY_START = `${CREATE_LIBRARY}_START`;
export const CREATE_LIBRARY_SUCCESS = `${CREATE_LIBRARY}_SUCCESS`;
export const CREATE_LIBRARY_FAIL = `${CREATE_LIBRARY}_FAIL`;

export const UPDATE_LIBRARY = 'UPDATE_LIBRARY';
export const UPDATE_LIBRARY_START = `${UPDATE_LIBRARY}_START`;
export const UPDATE_LIBRARY_SUCCESS = `${UPDATE_LIBRARY}_SUCCESS`;
export const UPDATE_LIBRARY_FAIL = `${UPDATE_LIBRARY}_FAIL`;

export const UPDATE_LIBRARY_PERMISSIONS = 'UPDATE_LIBRARY_PERMISSIONS';
export const UPDATE_LIBRARY_PERMISSIONS_START = `${UPDATE_LIBRARY_PERMISSIONS}_START`;
export const UPDATE_LIBRARY_PERMISSIONS_SUCCESS = `${UPDATE_LIBRARY_PERMISSIONS}_SUCCESS`;
export const UPDATE_LIBRARY_PERMISSIONS_FAIL = `${UPDATE_LIBRARY_PERMISSIONS}_FAIL`;

export const GET_LIBRARY = 'GET_LIBRARY';
export const GET_LIBRARY_START = `${GET_LIBRARY}_START`;
export const GET_LIBRARY_SUCCESS = `${GET_LIBRARY}_SUCCESS`;
export const GET_LIBRARY_FAIL = `${GET_LIBRARY}_FAIL`;

const LIBRARIES_URI = `/webapi/xm/1/libraries`;

export function loadLibraries() {
  return {
    type: GET_LIBRARIES,
    meta: {
      xmApi: true,
      uri: LIBRARIES_URI,
      method: 'getall',
    },
  };
}

export function createLibrary(name, script) {
  return {
    type: CREATE_LIBRARY,
    meta: {
      xmApi: true,
      uri: LIBRARIES_URI,
      method: 'post',
      params: {
        name,
        script: btoa(script),
        [ScriptStepPermissionConfigOptionDef.accessibleByAll]:
          ScriptStepPermissionDef.notShared,
      },
    },
  };
}

export function updateLibrary(id, updatedFields) {
  const fields = { ...updatedFields };
  if ('script' in fields) {
    fields.script = btoa(fields.script);
  }
  return {
    type: UPDATE_LIBRARY,
    meta: {
      xmApi: true,
      uri: LIBRARIES_URI,
      method: 'post',
      params: {
        id,
        ...fields,
      },
    },
  };
}

export function updateLibraryPermissions(id, fields) {
  return {
    type: UPDATE_LIBRARY_PERMISSIONS,
    meta: {
      xmApi: true,
      uri: LIBRARIES_URI,
      method: 'post',
      params: {
        id,
        ...fields,
      },
    },
  };
}

export function loadLibrary(id, opts) {
  const { withUsage } = opts || {};
  return {
    type: GET_LIBRARY,
    meta: {
      xmApi: true,
      uri: `${LIBRARIES_URI}/${id}${withUsage ? '?embed=usage' : ''}`,
      method: 'get',
    },
  };
}
